import { FunctionComponent } from 'react'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader.tsx'
import DialogBody from '@/components/_custom/DialogBody/DialogBody.tsx'
import Dialog from '@/components/_custom/Dialog/Dialog.tsx'
import { useTranslation } from 'react-i18next'
import styles from './publishPostDialog.module.scss'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon.tsx'
import { Check, Close } from '@mui/icons-material'
import { useMutation } from '@apollo/client'
import { PUBLISH_POST } from '@/modules/API/news/news.ts'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface PublishPostDialogProps {
    open: boolean
    handleClose: () => void
    daycareId: number
    postId: number
    refetch: () => void
}

const PublishPostDialog: FunctionComponent<PublishPostDialogProps> = ({
    open,
    handleClose,
    daycareId,
    postId,
    refetch
}: PublishPostDialogProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [publishPost] = useMutation(PUBLISH_POST, {
        variables: {
            postId,
            daycareId
        },
        onCompleted: () => {
            showNotificationSuccess(t('postPublished'))
            refetch()
            handleClose()
        },
        onError: () => {
            showNotificationError(t('postNotPublished'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('publish')} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('areYouSureYouWantToPublishThisPost')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Check />}
                        onClick={publishPost}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default PublishPostDialog
